import { useEffect } from 'react'

import BuyBonusButton from './BuyBonusButton'
import BuyBonusModal from './BuyBonusModal'
import { useBuyBonusStore, useConfigurationStore } from '@stores'
import {
    BuyBonusAtlasMapMessage,
    BuyBonusToggleAdditionalFeatureMessage,
    BuyBonusButtonClickedMessage,
    BuyBonusRejectedMessage,
    CollectClickedMessage,
    GameUIMessageScope,
    GameUIMessageType,
} from 'game-ui-types'

const BuyBonus = () => {
    const showModal = useBuyBonusStore((state) => state.showModal)
    const setShowModal = useBuyBonusStore((state) => state.setShowModal)
    const addAtlasMap = useBuyBonusStore((state) => state.addAtlasMap)
    const preloadImages = useBuyBonusStore((state) => state.preloadImages)
    const handleAtlasTexturesData = useBuyBonusStore((state) => state.handleAtlasTexturesData)
    const setMultiChoiceToggle = useBuyBonusStore((state) => state.setMultiChoiceToggle)
    const isMultiChoiceToggled = useBuyBonusStore((state) => state.isMultiChoiceToggled)
    const updateCurrentFeatureMultiplier = useBuyBonusStore((state) => state.updateCurrentFeatureMultiplier)

    const hasBuyBonus = useConfigurationStore((state) => state.hasBuyBonus)

    useEffect(() => {
        const handleMessage = (event: MessageEvent) => {
            const { type, scope } = event.data

            if (scope !== GameUIMessageScope.BUY_BONUS) {
                return
            }

            switch (type) {
                case GameUIMessageType.BUY_BONUS_SEND_BUY_BONUS_ATLAS_MAP: {
                    const data: BuyBonusAtlasMapMessage = event.data

                    addAtlasMap(data.atlasMap)

                    if (data.atlasTexturesData) {
                        handleAtlasTexturesData(data.atlasTexturesData)
                    } else {
                        preloadImages(Object.keys(data.atlasMap))
                    }

                    break
                }

                case GameUIMessageType.BUY_BONUS_TOGGLE_ADDITIONAL_FEATURE: {
                    const data = event.data as BuyBonusToggleAdditionalFeatureMessage

                    updateCurrentFeatureMultiplier(data.payload.multiplier)

                    break
                }
            }
        }

        window.addEventListener('message', handleMessage, false)

        return () => {
            window.removeEventListener('message', handleMessage, false)
        }
    }, [])

    const handleButtonClicked = () => {
        const collectClickedMessage: CollectClickedMessage = {
            type: GameUIMessageType.COLLECT_CLICKED,
        }

        window.postMessage(collectClickedMessage, '*')

        if (isMultiChoiceToggled) {
            setMultiChoiceToggle(false)
            updateCurrentFeatureMultiplier(1)

            const buyBonusRejectedMessage: BuyBonusRejectedMessage = {
                type: GameUIMessageType.BUY_BONUS_REJECTED,
                // scope: GameUIMessageScope.BUY_BONUS,
            }

            window.postMessage(buyBonusRejectedMessage)

            return
        }

        setShowModal(true)

        const buyBonusButtonClickedMessage: BuyBonusButtonClickedMessage = {
            type: GameUIMessageType.BUY_BONUS_BUTTON_CLICKED,
            scope: GameUIMessageScope.BUY_BONUS,
        }

        window.postMessage(buyBonusButtonClickedMessage)
    }

    return (
        <>
            {hasBuyBonus && (
                <>
                    <BuyBonusButton onClick={handleButtonClicked} />
                    <BuyBonusModal isOpen={showModal} onClose={() => setShowModal(false)} />
                </>
            )}
        </>
    )
}

export default BuyBonus
